<style lang="less">
.tree-posi {
  margin-left: 30px;
  margin-right: 70px;

  .filter {
    border-bottom: 1px solid #d8dcdf;
    padding-bottom: 13px;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    .clearkw {
      cursor: pointer;
    }
  }

  h3 {
    margin-top: 24px;
    margin-bottom: 10px;
    font-size: 14px;
  }
}
</style>

<template>
  <div class="tree-posi">
    <div class="filter">
      <span>{{ $t("join.filter") }}</span>
      <span class="clearkw" @click="clear">{{ $t("join.clear") }}</span>
    </div>

    <h3>{{ $t("join.posiType") }}</h3>
    <Tree :treeData.sync="posiData" @onSelect="onSelect1" />

    <h3>{{ $t("join.city") }}</h3>
    <Tree :treeData.sync="cityData" @onSelect="onSelect2" />

    <h3>{{ $t("join.type") }}</h3>
    <Tree :treeData.sync="typeData" @onSelect="onSelect3" />
  </div>
</template>
<script>
import Tree from "@/components/Tree";
import { GetPositionCategory } from "@/api/api";
export default {
  components: { Tree },
  data() {
    return {
      posiData: [
      ],
      cityData: [
        {
          check: false,
          label: "重庆",
          val: '重庆',
          child: [],
        },
        {
          check: false,
          label: "北京",
          val: '北京',
          child: [],
        },
        {
          check: false,
          label: "上海",
          val: '上海',
          child: [],
        },
      ],
      typeData: [
        {
          check: false,
          label: "社招",
          val: 0,
          child: [],
        },
        {
          check: false,
          label: "校招",
          val: 1,
          child: [],
        },
      ],
    };
  },
  created() {
    // this.getData();
    this.GetPositionCategory();
  },
  methods: {
    GetPositionCategory() {
      GetPositionCategory()
        .then(res => {
          var { code, data } = res;
          if (code === 0) {
            console.log(data)

            var posiData = [
              // {
              //   check: false,
              //   label: "不限",
              //   val: null,
              //   child: []
              // }
            ];
            for (let i = 0; i < data.length; i++) {
              var row = data[i];

              var obj = {
                check: false,
                label: row.categoryName,
                val: row.categoryName,
              };

              if (row.positions && row.positions.length > 0) {
                obj.child = [];
                for (let ii = 0; ii < row.positions.length; ii++) {
                  var item = row.positions[ii];
                  obj.child.push({
                    check: false,
                    label: item.name,
                    val: item.name,
                  })
                }
              }
              posiData.push(obj);
            }

            this.posiData = posiData;
          }
        })
    },
    clear() {
      this.$emit("onResult", null);
    },
    onSelect1(row) {
      console.log(row);
      this.$emit("onResult", {
        category: row.check ? row.label : "",
      });
    },
    onSelect2(row) {
      console.log(row);
      this.$emit("onResult", {
        city: row.check ? row.label : "",
      });
    },
    onSelect3(row) {
      console.log(row);
      this.$emit("onResult", {
        type: row.check ? row.val : -1,
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/join/Tree.vue